var MARC_COLORS = {
    0: { dark: '#475569', light: '#f8fafc', border: '#cbd5e1' }, // slate    — 0xx
    1: { dark: '#be123c', light: '#fff1f2', border: '#fecdd3' }, // rose     — 1xx main heading
    2: { dark: '#c2410c', light: '#fff7ed', border: '#fed7aa' }, // orange   — 2xx
    3: { dark: '#a16207', light: '#fefce8', border: '#fde68a' }, // amber    — 3xx
    4: { dark: '#4d7c0f', light: '#f7fee7', border: '#bef264' }, // lime     — 4xx variants
    5: { dark: '#047857', light: '#ecfdf5', border: '#a7f3d0' }, // emerald  — 5xx
    6: { dark: '#0e7490', light: '#ecfeff', border: '#a5f3fc' }, // cyan     — 6xx
    7: { dark: '#1d4ed8', light: '#eff6ff', border: '#bfdbfe' }, // blue     — 7xx
    8: { dark: '#7c3aed', light: '#f5f3ff', border: '#ddd6fe' }, // violet   — 8xx
    9: { dark: '#a21caf', light: '#fdf4ff', border: '#f0abfc' }, // fuchsia  — 9xx
};
var CONTROL_COLORS = { dark: '#6b7280', light: '#f9fafb', border: '#d1d5db' };
/**
 * Resolve the color set for a MARC tag.
 *
 * Returns gray (`CONTROL_COLORS`) for control fields (`tag < '010'`),
 * otherwise picks the entry for the tag's first digit. Falls back to
 * 0xx slate on a non-numeric tag string (defensive — should not happen
 * with validated form-configs).
 */
export var getMarcColors = function (tag) {
    if (tag < '010')
        return CONTROL_COLORS;
    var group = parseInt(tag.charAt(0), 10);
    return MARC_COLORS[isNaN(group) ? 0 : group];
};
